<template>
  <div
    :class="[
      `${createRenderType}-single-wave-wrapper`,
      'ingle-wave-wrapper',
      'flex',
    ]"
  >
    <div class="info flex-center">
      <div class="operate flex-center">
        <img
          src="@/assets/img/editor/download.png"
          alt=""
          @click.stop="handleDown"
        />
      </div>
      <div
        class="operate flex-center"
        :class="active ? 'active-operate' : ''"
        @click.stop="handleSolo"
      >
        S
      </div>
      <Bubble :content="$t(`editor.${data?.title}`)" placement="top">
        <div class="name flex1 olh">{{ $t(`editor.${data?.title}`) }}</div>
      </Bubble>
    </div>
    <div class="wave-wrapper flex1" :style="{ backgroundColor: backgroundColor }">
      <div class="wave" >
        <AudioWavForm
          :style="{
            '--progressColor': '#fff',
            '--progressTrasform': 'scaleY(2.4)',
          }"
          :config="defaultConfig"
          :waveformData="data?.waves"
          :url="data?.url"
          :showChangeProgress="false"
          :progress="progress / 100"
          @changeProgress="changeProgress"
          :hideChangeProgress="true"
        ></AudioWavForm>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, watch } from "vue";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import AudioWavForm from "@/components/media/audioPlayer/AudioWavForm.vue";
import Bubble from "@/components/bubble/bubble.vue";

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const emits = defineEmits(["changeProgress", "handleSolo", "handleDown"]);
const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  inActive: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => {
      return {};
    },
  },
  duration: {
    type: Number,
    default: 0,
  },
  backgroundColor: {
    type: String,
    default: "",
  },
  progress: {
    type: Number,
    default: 0, // 0 表示起点
  },
});

const defaultConfig = ref({
  spacingSize: 3,
  wavebarWidth: 1,
  startColor: "#72FFEC",
  endColor: "#72FFEC",
  defaultColor: "#000",
  progressColor: "#fff",
});

watch(
  () => props.inActive,
  (val) => {
    defaultConfig.value = {
      ...defaultConfig.value,
      progressColor: val ? "#000" : "#fff",
    };
  }
);

const changeProgress = (progress) => {
  emits("changeProgress", progress * 100);
};

const handleSolo = () => {
  emits("handleSolo");
};

const handleDown = () => {
  emits("handleDown");
};
</script> 

<style lang="scss" scoped>
.pc-single-wave-wrapper {
  height: 56px;
  .info {
    background: #000;
    padding: 16px 8px 16px 12px;
    border-radius: 8px 0 0 8px;
    width: 136px;
    .operate {
      width: 24px;
      height: 24px;
      background: rgba(255, 255, 255, 0.3);
      font-size: 15px;
      font-weight: 500;
      margin-right: 8px;
      color: #fff;
      border-radius: 4px;
      cursor: pointer;

      img {
        width: 12px;
        height: 14px;
      }
    }
    .active-operate {
      background: #94adff;
    }
    .name {
      font-size: 13px;
      font-weight: 500;
    }
  }
  .wave-wrapper {
    padding: 16px 0;
    border-radius: 0 8px 8px 0;
    .wave {
      height: 100%;
      cursor: pointer;
      border-radius: 0px 8px 8px 0;
    }
  }
}
.mobile-single-wave-wrapper {
  height: 56px;
  .info {
    background: #314355;
    padding: 16px 10px;
    border-radius: 8px 0 0 8px;
    width: 126px;
    flex-shrink: 0;
    .operate {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      background: rgba(255, 255, 255, 0.3);
      font-size: 15px;
      font-weight: 500;
      margin-right: 8px;
      border-radius: 4px;
      color: #fff;
      img {
        width: 12px;
        height: 14px;
      }
    }
    .active-operate {
      background: #94adff;
    }
    .name {
      font-size: 13px;
      font-weight: 500;
    }
  }
  .wave-wrapper {
    padding: 16px 0;
    border-radius: 0px 8px 8px 0;
    width: 0;
    .wave {
      height: 100%;
      cursor: pointer;
      // border-radius: 0px 8px 8px 0;
    }
  }
}
</style>